/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * ClientAdapter.tsx
 */

import ListAdapter, { AdapterListener } from "../../tools/list/ListAdapter";
import Client from "../../models/Client";
import React from "react";
import { Column } from "../../tools/list/Column"
import Translation from "../../services/translation/Translation";
import ClientDataProvider from "../../provider/ClientDataProvider";
import { ClientAPIPagination } from "../../pagination/ClientAPIPagination";
import { GrantType } from "../../tools/model/auth/GrantType";
import { Criterion } from "../../tools/model/pagination/Criterion";

export interface ClientAdapterListener extends AdapterListener<Client> {
}

export default class ClientAdapter extends ListAdapter<Client, ClientAdapterListener, ClientAPIPagination> {
    private _t: Translation;

    /**
     * constructor
     * @param clientsProvider
     * @param listener
     * @param t
     */
    constructor(t: Translation, clientsProvider: ClientDataProvider, listener?: ClientAdapterListener) {
        super();

        this._t = t;
        this.addColumn(new Column(t.clientListColName, "name", this._name));
        this.addColumn(new Column(t.clientListColID, "id", this._id));
        this.addColumn(new Column(t.clientListColEnabled, "enabled", this._enabled));
        this.addColumn(new Column(t.openRegistrationShort, "openRegistration", this._openRegistration));
        this.addColumn(new Column(t.clientListColScope, "scope", this._scopes));

        this.init(
            t.clientListEmpty,
            clientsProvider,
            Object.values(GrantType).map(r => new Criterion(ClientAPIPagination.GRANT_TYPE_FILTER, r.toString(), r.toString())),
            listener
        );

        this.criteria.unshift({ relatedFilterKey: ClientAPIPagination.GRANT_TYPE_FILTER, translationKey: "all", value: "all" });
    }

    /**
     * _id
     * @returns {any}
     * @private
     * @param client
     */
    private _id = (client: Client): JSX.Element => {
        return <p className={"blue-hover"}>{client.client_id}</p>
    };

    /**
     * _name
     * @returns {any}
     * @private
     * @param client
     */
    private _name = (client: Client): JSX.Element => {
        return <p className={"blue-hover"}>{client.name}</p>
    };

    /**
     * _enabled
     * @returns {any}
     * @private
     * @param client
     */
    private _enabled = (client: Client): JSX.Element => {
        return <input type="checkbox" readOnly checked={client.enabled} />
    };

    /**
     * _openRegistration
     * @returns {any}
     * @private
     * @param client
     */
    private _openRegistration = (client: Client): JSX.Element => {
        return <input type="checkbox" readOnly checked={client.open_registration} />
    };

    /**
     * _scopes
     * @returns {any}
     * @private
     * @param client
     */
    private _scopes = (client: Client): JSX.Element => {
        return <p>{client.scope}</p>
    };

    /**
     * _clients
     * @returns {any}
     * @private
     * @param user
     */
    private _clients = (client: Client): JSX.Element => {
        return <p style={{ fontWeight: 800, color: client.clients.length === 0 ? "#FF0000" : "#000000" }}>
            {client.clients.length}
        </p>
    };
}